import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import EquipmentGroupActions from "../../Actions/EquipmentGroupActions";
import commonUtils from "../../helpers/commonUtils";
import { useLanguageContext } from "../../Context/LanguageContext";
import TypeAhead from "../AddRole/TypeAhead";
import equipmentGroupStore from "../../Stores/EquipmentGroupStore";
import EquipmentGroupContants from "../../Constants/EquipmentGroupConstants";
import ConfirmationPopUp from "../MessageBox/ConfirmationPopUp";
import { useRef } from "react";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import ReusableCard from "../ReusableComponent/ReusableCard";
import EnhancedTable from "../ReusableComponent/MuiTable";
import pruefPlanStores from "../../Stores/PruefPlanStore";
import pruef_PlanConstants from "../../Constants/Pruef_PlanConstants";

const AddTestGroupToEquipmentGroup = (props) => {
  const { egDetails, equipmentGrpName, equipmentGrpId, handleCompleted } =
    props.data;
  const [searchedTestGroupList, setSearchedTestGroupList] = useState([]);
  const [testGroupList, setTestGroupList] = useState([]);
  const [selectedTestGroupId, setSelectedTestGroupId] = useState(0);
  const [confirmationPopUpOpen, setConfirmationPopUpOpen] = useState(false);
  const [confirmationPopUpMsg, setConfirmationPopUpMsg] = useState("");
  const [buttonStatus, setbuttonStatus] = useState(true);
  const [callbackData, setCallbackData] = useState(null);
  const [listItem, setListItem] = useState([]);
  const [eventType, setEventType] = useState(null);
  const [itemSelected, setItemSelected] = useState(0);
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const equipmentGroupId = useRef("");
  const typeHeadRef = useRef("");
  const text = (
    <div className="row justify-content-center reusableCard pl-5 pr-5">
      <p>
        {localization.msg1 + " ? " + localization.msg2}
        <span className="reusableCardLink">
          {" "}
          <RenderAddPruefGroup />
        </span>
        .
      </p>
    </div>
  );
  let equpAddedlist = useRef([]);

  const searchForTestGroup = (inputString) => {
    setGlobalSpinner(true);
    EquipmentGroupActions.getTestGroups(inputString);
  };

  const getTestGroupByEquGroupId = (equGrpId) => {
    EquipmentGroupActions.getTestGroupByEquGrpId(equGrpId);
    setGlobalSpinner(true);
  };

  useEffect(() => {
    if (selectedTestGroupId !== 0) {
      setbuttonStatus(false);
    } else {
      setbuttonStatus(true);
    }
  }, [selectedTestGroupId]);

  useEffect(() => {
    if (equipmentGrpId) {
      equipmentGroupId.current = equipmentGrpId;
      getTestGroupByEquGroupId(equipmentGrpId);
    }

    return () => {};
  }, [equipmentGrpId]);

  useEffect(() => {
    let _tempItem = [];
    equpAddedlist.current = testGroupList.map((items) => {
      _tempItem.push({
        id: items.id,
        label: items.bezeichnung,
      });
      return items.id;
    });
    setListItem(_tempItem);
  }, [testGroupList]);

  useEffect(() => {
    function addorUpdatePruefGroupSuccess() {
      const res = pruefPlanStores.getAddorUpdatePruefGroupResult();

      if (res) {
        commonUtils.hideModalPopUp("addPruefGroupModalClose");
        toast.success(
          commonUtils.getIsEdit()
            ? localization.pruefGroupEditedSuccessfully
            : localization.pruefGroupAddSuccessfully,
        );
        if (!commonUtils.getIsEdit()) {
          EquipmentGroupActions.AddTestGroupToEquGroup({
            PruefGroupID: res.id,
            AnlagegruppeID: equipmentGrpId,
          });
        }
      } else {
        toast.error(res);
      }
      setGlobalSpinner(false);
    }

    function addorUpdatePruefGroupFailure() {
      const res = pruefPlanStores.getAddorUpdatePruefGroupResult();

      toast.error(res);
      setGlobalSpinner(false);
    }

    pruefPlanStores.addChangeListener(
      pruef_PlanConstants.ADDORUPDATE_PruefGroup_SUCCESS,
      addorUpdatePruefGroupSuccess,
    );

    pruefPlanStores.addChangeListener(
      pruef_PlanConstants.ADDORUPDATE_PruefGroup_FAILURE,
      addorUpdatePruefGroupFailure,
    );

    return () => {
      pruefPlanStores.removeChangeListener(
        pruef_PlanConstants.ADDORUPDATE_PruefGroup_SUCCESS,
        addorUpdatePruefGroupSuccess,
      );

      pruefPlanStores.removeChangeListener(
        pruef_PlanConstants.ADDORUPDATE_PruefGroup_FAILURE,
        addorUpdatePruefGroupFailure,
      );
    };
  }, []);
  const addTestGroupToEquGroup = (e) => {
    e.preventDefault();
    var TestGroupData = {
      PruefGroupID: selectedTestGroupId,
      AnlagegruppeID: equipmentGrpId,
    };
    setGlobalSpinner(true);

    EquipmentGroupActions.AddTestGroupToEquGroup(TestGroupData);
  };

  useEffect(() => {
    function addTestGroupToEquGroupSuccess() {
      var res = equipmentGroupStore.getAddTestGroupResult();

      if (res) {
        getTestGroupByEquGroupId(equipmentGroupId.current);
        setSelectedTestGroupId(0);
        toast.success(localization.testGroupAddedSuccessfully);

        typeHeadRef.current.resetTypeHead();
      }

      setGlobalSpinner(false);
    }

    function addTestGroupToEquGroupFailure() {
      var res = equipmentGroupStore.getAddTestGroupResult();
      toast.error(res);
      setGlobalSpinner(false);
    }

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.ADD_TEST_GROUP_TO_EQU_GROUP_SUCCESS,
      addTestGroupToEquGroupSuccess,
    );

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.ADD_TEST_GROUP_TO_EQU_GROUP_FAILURE,
      addTestGroupToEquGroupFailure,
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.ADD_TEST_GROUP_TO_EQU_GROUP_SUCCESS,
        addTestGroupToEquGroupSuccess,
      );

      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.ADD_TEST_GROUP_TO_EQU_GROUP_FAILURE,
        addTestGroupToEquGroupFailure,
      );
    };
  }, []);

  useEffect(() => {
    function getTestGroupByEquGroupIdSuccess() {
      var res = equipmentGroupStore.getTestGroupByEquGrpIdResult();

      if (res.length > 0) {
        setTestGroupList(res);
      } else {
        setTestGroupList(res);
        setTestGroupList([]);
      }
      EquipmentGroupActions.getSummaryEqGrp(equipmentGrpId);
    }

    function getTestGroupByEquGroupIdFailure() {
      setGlobalSpinner(false);
    }

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_TEST_GROUP_BY_EQUGROUP_ID_SUCCESS,
      getTestGroupByEquGroupIdSuccess,
    );

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_TEST_GROUP_BY_EQUGROUP_ID_FAILURE,
      getTestGroupByEquGroupIdFailure,
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_TEST_GROUP_BY_EQUGROUP_ID_SUCCESS,
        getTestGroupByEquGroupIdSuccess,
      );

      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_TEST_GROUP_BY_EQUGROUP_ID_FAILURE,
        getTestGroupByEquGroupIdFailure,
      );
    };
  }, []);

  useEffect(() => {
    function deleteTestGroupForEquGrpSuccess() {
      var res = equipmentGroupStore.getDeleteTestGroupForEquGrpResult();

      if (res.length > 0) {
        res.forEach((item) => toast.error(item));
      } else {
        toast.success(localization.testGroupRemovedSuccessfully);
      }
      getTestGroupByEquGroupId(equipmentGroupId.current);
    }

    function deleteTestGroupForEquGrpFailure() {
      var res = equipmentGroupStore.getDeleteTestGroupForEquGrpResult();
      toast.error(res);
      setGlobalSpinner(false);
    }

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.DELETE_TEST_GROUP_FOR_EQUGROUP_SUCCESS,
      deleteTestGroupForEquGrpSuccess,
    );

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.DELETE_TEST_GROUP_FOR_EQUGROUP_FAILURE,
      deleteTestGroupForEquGrpFailure,
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.DELETE_TEST_GROUP_FOR_EQUGROUP_SUCCESS,
        deleteTestGroupForEquGrpSuccess,
      );

      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.DELETE_TEST_GROUP_FOR_EQUGROUP_FAILURE,
        deleteTestGroupForEquGrpFailure,
      );
    };
  }, []);

  useEffect(() => {
    function searchTestGroupListSuccess() {
      var res = equipmentGroupStore.getTestGroupResult();

      let equList = [];
      if (res.length > 0) {
        res.map((key, index) => {
          equList.push({ id: key.id, label: key.bezeichnung });
        });
        const tempList = equList.filter((items) => {
          return equpAddedlist.current.every((element) => {
            return element != items.id;
          });
        });
        setSearchedTestGroupList(tempList);
      } else {
        setSearchedTestGroupList([]);
      }
      setGlobalSpinner(false);
    }

    function searchTestGroupListFailure() {
      setGlobalSpinner(false);
    }

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_TEST_GROUP_SUCCESS,
      searchTestGroupListSuccess,
    );

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_TEST_GROUP_FAILURE,
      searchTestGroupListFailure,
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_TEST_GROUP_SUCCESS,
        searchTestGroupListSuccess,
      );

      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_TEST_GROUP_FAILURE,
        searchTestGroupListFailure,
      );
    };
  }, [searchedTestGroupList]);

  const typeAheadInputChangeCallback = (text) => {
    if (text !== "") {
      searchForTestGroup(text);
    } else {
      setSelectedTestGroupId(0);
    }
  };

  const typeAheadSelectedCallback = (selectedList) => {
    if (selectedList && selectedList.length > 0) {
      setSelectedTestGroupId(selectedList[0].id);
    }
  };

  function handleSelectedItem() {
    setSelectedTestGroupId(0);
  }

  function handleDeleteButton(props) {
    setConfirmationPopUpOpen(true);
    setConfirmationPopUpMsg(
      localization.deleteWithout +
        " " +
        itemSelected.length +
        " " +
        localization.pruefGroup +
        " ?",
    );
    setCallbackData({
      equGrpId: equipmentGrpId,
      testGroupId: itemSelected,
    });
    setEventType("DELETE_TEST_GROUP_FOR_EQU_GRP");
  }

  const confirmationOkCancelCallback = (isConfirmed, eventType, data) => {
    if (isConfirmed) {
      switch (eventType) {
        case "DELETE_TEST_GROUP_FOR_EQU_GRP":
          setGlobalSpinner(true);
          EquipmentGroupActions.deleteTestGroupForEquGroup(
            data.equGrpId,
            data.testGroupId,
          );
          closePopUpCallback();
          break;
        default:
          break;
      }
    } else {
      closePopUpCallback();
    }
  };

  const closePopUpCallback = () => {
    setConfirmationPopUpOpen(false);
    setConfirmationPopUpMsg("");
    setCallbackData(null);
    setEventType(null);
  };

  function RenderAddPruefGroup() {
    return (
      <>
        <span
          className="cursorPoint svgIcon"
          id="addTestGroup"
          size={27}
          onClick={() => {}}
          data-toggle="modal"
          data-target="#addPruefGroup"
        >
          {localization.here}
        </span>
      </>
    );
  }
  return (
    <>
      <div className="row d-flex justify-content-center">
        <ReusableCard
          title=""
          func={addTestGroupToEquGroup}
          buttonStatus={buttonStatus}
          buttonname={localization.save}
          text={text}
        >
          <TypeAhead
            ref={typeHeadRef}
            typeAheadInputChangeCallback={typeAheadInputChangeCallback}
            typeAheadSelectedCallback={typeAheadSelectedCallback}
            isMultiple={false}
            searchedList={searchedTestGroupList}
            resetSelectedItem={handleSelectedItem}
          />
        </ReusableCard>
      </div>
      <EnhancedTable
        tableHeaders={[localization.name]}
        ItemList={listItem}
        title={localization.testGroup}
        columnName={localization.name}
        deletdHandle={handleDeleteButton}
        setItemSelected={setItemSelected}
      />
      <ConfirmationPopUp
        isOpen={confirmationPopUpOpen}
        okCancelCallback={confirmationOkCancelCallback}
        close={closePopUpCallback}
        title=""
        msg={confirmationPopUpMsg}
        eventType={eventType}
        callbackData={callbackData}
      />
    </>
  );
};

export default AddTestGroupToEquipmentGroup;
